export const lectures = [
  {
    id: "1",
    category: "beginner",
    categoryLabel: "입문/기초",
    title: "경매, 이것만 알면 시작할 수 있다",
    description: "경매의 기본 개념, 용어 정리, 실제 입찰까지 진행되는 전체 프로세스를 가장 쉽게 설명합니다.",
    duration: "18:24",
    isFree: true,
    difficulty: "초급",
    tags: ["#경매기초", "#용어정리", "#입찰프로세스"],
    thumbnail: "https://img.echotwin.kr/kangstudy/91979a31ca76a5c5.jpg",
    instructor: "강현우",
    views: 12500,
    likes: 842,
    curriculum: [
      { chapter: "1", title: "경매란 무엇인가?", duration: "4:20" },
      { chapter: "2", title: "경매의 3가지 종류", duration: "3:50" },
      { chapter: "3", title: "입찰부터 낙찰까지 프로세스", duration: "5:10" },
      { chapter: "4", title: "꼭 알아야 할 경매 용어 20선", duration: "5:04" },
    ],
    previewContent: [
      "경매의 기본 개념과 용어 이해",
      "법원 경매 vs 공매의 차이점",
      "입찰 진행의 전체 타임라인",
      "초보자가 가장 많이 하는 실수 TOP 5",
    ],
  },
  {
    id: "2",
    category: "beginner",
    categoryLabel: "입문/기초",
    title: "법원 경매 정보 사이트 200% 활용법",
    description: "대법원 경매정보 사이트에서 필요한 정보를 빠르게 찾고 분석하는 실전 노하우를 알려드립니다.",
    duration: "22:10",
    isFree: true,
    difficulty: "초급",
    tags: ["#대법원", "#경매검색", "#물건찾기"],
    thumbnail: "https://img.echotwin.kr/kangstudy/f301ed09acb2f9fa.jpg",
    instructor: "강현우",
    views: 8900,
    likes: 623,
    curriculum: [
      { chapter: "1", title: "경매정보 사이트 메뉴 구조 파악", duration: "5:30" },
      { chapter: "2", title: "원하는 물건 빠르게 찾는 검색 필터", duration: "6:10" },
      { chapter: "3", title: "물건 상세정보 100% 읽는 법", duration: "5:50" },
      { chapter: "4", title: "관심 물건 알림 설정 꿀팁", duration: "4:40" },
    ],
    previewContent: [
      "대법원 경매정보 사이트 완전 정복",
      "숨은 물건 찾는 검색 노하우",
      "상세정보에서 놓치기 쉬운 핵심 포인트",
    ],
  },
  {
    id: "3",
    category: "rights",
    categoryLabel: "권리분석",
    title: "등기부등본 완전 정복 - 말소기준권리 찾기",
    description: "등기부등본 보는 법부터 말소기준권리, 배당순위까지 실제 등기부등본으로 실습합니다.",
    duration: "28:45",
    isFree: false,
    difficulty: "중급",
    tags: ["#등기부등본", "#말소기준권리", "#배당순위"],
    thumbnail: "https://img.echotwin.kr/kangstudy/6d7ece55d0c65972.jpg",
    instructor: "김민재",
    views: 7200,
    likes: 534,
    curriculum: [
      { chapter: "1", title: "등기부등본의 3가지 구성 요소", duration: "6:15" },
      { chapter: "2", title: "갑구·을구 완전 분석", duration: "7:20" },
      { chapter: "3", title: "말소기준권리 찾기 실습", duration: "8:10" },
      { chapter: "4", title: "실제 사례로 배우는 배당순위", duration: "7:00" },
    ],
    previewContent: [
      "등기부등본 구조 한눈에 이해하기",
      "말소되는 권리 vs 인수되는 권리 구분법",
      "배당순위표 읽는 실전 노하우",
    ],
  },
  {
    id: "4",
    category: "rights",
    categoryLabel: "권리분석",
    title: "임차인 권리분석 - 대항력과 우선변제권",
    description: "임차인의 대항력, 우선변제권, 최우선변제권을 실제 판례로 이해하는 강의입니다.",
    duration: "25:30",
    isFree: false,
    difficulty: "중급",
    tags: ["#임차인", "#대항력", "#우선변제권"],
    thumbnail: "https://img.echotwin.kr/kangstudy/5ef1990951241b3e.jpg",
    instructor: "김민재",
    views: 5400,
    likes: 389,
    curriculum: [
      { chapter: "1", title: "임차인 권리 개요", duration: "5:50" },
      { chapter: "2", title: "대항력 요건과 판단 기준", duration: "6:40" },
      { chapter: "3", title: "우선변제권과 최우선변제권", duration: "7:20" },
      { chapter: "4", title: "실제 판례로 배우는 분쟁 사례", duration: "5:40" },
    ],
    previewContent: [
      "대항력·우선변제권의 핵심 개념 정리",
      "임차인 보호 범위와 한계",
      "실제 법원 판결로 이해하는 권리 관계",
    ],
  },
  {
    id: "5",
    category: "advanced",
    categoryLabel: "실전/명도",
    title: "명도 실무 A to Z - 임차인과의 협상부터 강제집행까지",
    description: "명도 절차의 모든 과정을 실제 사례 중심으로 배우는 실전 강의입니다.",
    duration: "35:20",
    isFree: false,
    difficulty: "상급",
    tags: ["#명도실무", "#임차인협상", "#강제집행"],
    thumbnail: "https://img.echotwin.kr/kangstudy/995a43b192780fdf.jpg",
    instructor: "박상민",
    views: 3800,
    likes: 267,
    curriculum: [
      { chapter: "1", title: "명도 절차 개요 및 법적 근거", duration: "6:30" },
      { chapter: "2", title: "임차인과의 협상 전략", duration: "8:15" },
      { chapter: "3", title: "명도소송 제기부터 판결까지", duration: "10:40" },
      { chapter: "4", title: "강제집행 실무와 주의사항", duration: "9:55" },
    ],
    previewContent: [
      "명도 진행이 어려운 진짜 이유",
      "임차인과 원만히 합의하는 협상 기술",
      "강제집행 시 반드시 체크할 포인트",
    ],
  },
  {
    id: "6",
    category: "advanced",
    categoryLabel: "실전/명도",
    title: "수익률 계산 마스터 - 적정 입찰가 도출하기",
    description: "매각대금, 취득세, 명도비용 등 모든 비용을 고려한 정확한 수익률 계산법을 배웁니다.",
    duration: "32:15",
    isFree: false,
    difficulty: "중급",
    tags: ["#수익률계산", "#입찰가산정", "#비용분석"],
    thumbnail: "https://img.echotwin.kr/kangstudy/1f9b9972b06f7f01.jpg",
    instructor: "강현우",
    views: 6300,
    likes: 445,
    curriculum: [
      { chapter: "1", title: "취득 시 발생하는 모든 비용 정리", duration: "7:10" },
      { chapter: "2", title: "보유 기간별 예상 수익 시뮬레이션", duration: "8:25" },
      { chapter: "3", title: "적정 입찰가 도출 공식", duration: "9:40" },
      { chapter: "4", title: "실제 사례로 따라하는 수익률 계산", duration: "7:00" },
    ],
    previewContent: [
      "숨은 비용까지 포함한 진짜 수익률 계산법",
      "초보자가 흔히 놓치는 비용 항목 3가지",
      "수익률 시뮬레이션 엑셀 템플릿 소개",
    ],
  },
  {
    id: "7",
    category: "rights",
    categoryLabel: "권리분석",
    title: "가등기·가처분·압류 - 복잡한 권리관계 해석하기",
    description: "등기부등본에 나오는 다양한 권리들의 의미와 우선순위를 체계적으로 정리해드립니다.",
    duration: "26:30",
    isFree: false,
    difficulty: "중급",
    tags: ["#가등기", "#가처분", "#압류", "#권리분석"],
    thumbnail: "https://img.echotwin.kr/kangstudy/ac6b6736f904aae6.jpg",
    instructor: "김민재",
    views: 3500,
    likes: 212,
    curriculum: [
      { chapter: "1", title: "가등기의 종류와 효력", duration: "6:00" },
      { chapter: "2", title: "가처분의 의미와 대응 방법", duration: "7:15" },
      { chapter: "3", title: "압류·가압류 권리 분석", duration: "6:45" },
      { chapter: "4", title: "복합 권리관계 실제 해석 사례", duration: "6:30" },
    ],
    previewContent: [
      "가등기만 보고도 물건 상태를 파악하는 법",
      "가처분이 걸린 물건, 사도 될까?",
      "압류 권리 해석 3단계 프레임워크",
    ],
  },
  {
    id: "8",
    category: "advanced",
    categoryLabel: "실전/명도",
    title: "명도소송 실전 - 소장 작성부터 판결까지",
    description: "명도소송 진행 시 필요한 서류 준비와 법원 절차를 단계별로 설명합니다.",
    duration: "27:40",
    isFree: false,
    difficulty: "상급",
    tags: ["#명도소송", "#소장작성", "#법원절차"],
    thumbnail: "https://img.echotwin.kr/kangstudy/f6a7f4ef3923cf90.jpg",
    instructor: "박상민",
    views: 2900,
    likes: 178,
    curriculum: [
      { chapter: "1", title: "명도소송 제기 전 준비사항", duration: "6:20" },
      { chapter: "2", title: "소장 작성 실전 가이드", duration: "7:50" },
      { chapter: "3", title: "법원 심리 및 변론 전략", duration: "7:30" },
      { chapter: "4", title: "판결 후 강제집행까지", duration: "6:00" },
    ],
    previewContent: [
      "명도소송, 언제 시작하는 게 좋을까?",
      "소장에 반드시 포함해야 할 핵심 내용",
      "승소 후 빠른 집행을 위한 체크리스트",
    ],
  },
  {
    id: "9",
    category: "beginner",
    categoryLabel: "입문/기초",
    title: "경매 투자, 얼마로 시작할 수 있을까?",
    description: "초보자가 첫 경매 투자를 위해 필요한 자금 규모와 준비 방법을 현실적으로 알려드립니다.",
    duration: "15:40",
    isFree: true,
    difficulty: "초급",
    tags: ["#경매투자", "#초기자금", "#현실조언"],
    thumbnail: "https://img.echotwin.kr/kangstudy/41af527c0de131c4.jpg",
    instructor: "강현우",
    views: 10300,
    likes: 756,
    curriculum: [
      { chapter: "1", title: "경매 투자에 필요한 최소 자금", duration: "4:30" },
      { chapter: "2", title: "대출 활용 전략과 한도 계산", duration: "5:10" },
      { chapter: "3", title: "예비비 산정 방법", duration: "3:40" },
      { chapter: "4", title: "초보자를 위한 현실적인 투자 로드맵", duration: "2:20" },
    ],
    previewContent: [
      "적은 자본으로 시작하는 경매 투자 전략",
      "대출 상품별 장단점 비교",
      "첫 투자 전 반드시 준비해야 할 3가지",
    ],
  },
  {
    id: "10",
    category: "advanced",
    categoryLabel: "실전/명도",
    title: "경쟁자 분석 - 입찰 당일 전략",
    description: "입찰 당일 현장에서 경쟁자를 분석하고 최적의 입찰가를 결정하는 실전 전략 강의입니다.",
    duration: "19:50",
    isFree: false,
    difficulty: "중급",
    tags: ["#입찰전략", "#경쟁분석", "#현장노하우"],
    thumbnail: "https://img.echotwin.kr/kangstudy/49a9fae769073302.jpg",
    instructor: "강현우",
    views: 4100,
    likes: 298,
    curriculum: [
      { chapter: "1", title: "입찰 당일 체크해야 할 사항", duration: "4:50" },
      { chapter: "2", title: "경쟁자 유형 파악과 분석", duration: "5:20" },
      { chapter: "3", title: "실시간 입찰가 조정 전략", duration: "5:10" },
      { chapter: "4", title: "실패 사례로 배우는 반면교사", duration: "4:30" },
    ],
    previewContent: [
      "입찰장에서 경쟁자 숫자 읽는 법",
      "막판 입찰가 조정이 필요한 순간",
      "경쟁자를 이기는 심리 전략",
    ],
  },
];

export const categories = [
  { key: "all", label: "전체" },
  { key: "free", label: "무료 맛보기" },
  { key: "beginner", label: "입문/기초" },
  { key: "rights", label: "권리분석" },
  { key: "advanced", label: "실전/명도" },
];

export const difficultyConfig = {
  초급: { bg: "bg-emerald-50", text: "text-emerald-600", border: "border-emerald-200" },
  중급: { bg: "bg-amber-50", text: "text-amber-600", border: "border-amber-200" },
  상급: { bg: "bg-rose-50", text: "text-rose-600", border: "border-rose-200" },
};